'use client';

var translations = {
    Following: 'Đang theo dõi',
    Follow: 'Theo dõi',
    'opening jobs': 'việc làm',
    'opening job': 'việc làm',
    Unfollowed: 'Đã bỏ theo dõi',
    Unfollow: 'Bỏ theo dõi',
    'Unfollow company?': 'Bỏ theo dõi công ty?',
    "You'll stop receive the newest jobs from this company.": 'Bạn sẽ ngừng nhận thông báo về công việc mới nhất từ ​​công ty này.',
    'Yay! Thanks for following': 'Cảm ơn bạn đã theo dõi',
    'You will receive the newest jobs from this company.': 'Bạn sẽ nhận được thông báo về công việc mới nhất từ công ty này.',
    'You will not able to received notifications from this company.': 'Bạn sẽ ngừng nhận thông tin việc làm từ công ty này.',
    followers: 'lượt theo dõi',
    follower: 'lượt theo dõi',
    Negotiate: 'Thương Lượng',
    'View company profile': 'Xem công ty',
    'No opening jobs': 'Chưa có công việc đang tuyển',
    'Invited by employer': 'Được mời ứng tuyển'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
